// extracted by mini-css-extract-plugin
module.exports = {"Comment":"Comment_Comment__2-z2j","Content":"Comment_Content__2d9WE","Btns":"Comment_Btns__3dd2f"};